// routes/index.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Landing } from "../pages/Landing";
import { NotFound } from "../pages/NotFound";
import { OurTours } from "../pages/OurTours";
import { AboutUs } from "../pages/AboutUs";
import { FAQ } from "../pages/FAQ";
import { OurServices } from "../pages/OurServices";
import { Drone } from "../pages/Drone";
import { Blog } from "../pages/Blog";
import { Contact } from "../pages/Contact";
import { Gallery } from "../pages/Gallery";
import { WithOrWithoutDriver } from "../pages/WithOrWithoutDriver";
import { DropOffPickupServices } from "../pages/DropOffPickupServices";
import { PremiumComfort } from "../pages/PremiumComfort";
import { Post } from "../pages/Post";
import Admin from "../pages/Admin";
import { PrivacyPolicy } from "../pages/PrivacyPolicy";

export const AppRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/our-tours" element={<OurTours />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/drone" element={<Drone />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/blog/:slug" element={<Post />} />
          <Route path="/services" element={<OurServices />} />
          <Route
            path="/drop-off-and-pickup-services"
            element={<DropOffPickupServices />}
          />
          <Route
            path="/with-or-without-driver"
            element={<WithOrWithoutDriver />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/premium-comfort" element={<PremiumComfort />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
};
